/* eslint-disable prefer-template */
import React from "react"

export default function formatAmountComponent (value)  {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}